import { IPlatform } from './types';

export function detectPlatform(): IPlatform {
  const isTelegram =
    typeof window !== 'undefined' &&
    (window as any).Telegram?.WebApp !== undefined;

  return {
    type: isTelegram ? 'telegram' : 'web',
    isTelegram,
  };
}